module.exports = __webpack_public_path__ + "img/2019-03-04.870fc63b.jpg";